import React, { useEffect } from "react";
import styled, { keyframes } from "styled-components";

const Donate = () => {
  useEffect(() => {
    // Prevent multiple script loads
    if (document.getElementById("paypal-donate-script")) return;

    const script = document.createElement("script");
    script.src = "https://www.paypalobjects.com/donate/sdk/donate-sdk.js";
    script.charset = "UTF-8";
    script.id = "paypal-donate-script"; // ✅ Unique ID to prevent reloading

    script.onload = () => {
      if (window.PayPal && !document.querySelector("#donate-button-container .paypal-button")) {
        window.PayPal.Donation.Button({
          env: "production",
          hosted_button_id: "7N8WBEBWGRBNY",
          image: {
            src: "https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif",
            alt: "Donate with PayPal button",
            title: "PayPal - The safer, easier way to pay online!",
          },
        }).render("#donate-button");
      }
    };

    document.body.appendChild(script);
  }, []);

  return (
    <DonateContainer>
      <h1>Support Our Mission</h1>
      <p>Your donation helps us continue our work to uplift and empower people in need. Every contribution makes a difference.</p>
      <div id="donate-button-container">
        <div id="donate-button"></div>
      </div>
    </DonateContainer>
  );
};

export default Donate;

// Styled Components
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const DonateContainer = styled.div`
  text-align: center;
  padding: 100px 20px;
  background: #fff;
  color: #000;
  animation: ${fadeIn} 1s ease-out;

  h1 {
    font-size: 2.8rem;
    margin-bottom: 20px;
  }

  p {
    font-size: 1.4rem;
    max-width: 700px;
    margin: 0 auto 30px;
    line-height: 1.6;
  }
`;